import {Init} from '@/core/Init'
import {APP_EVT, APP_LOCATION, SERIES_ID} from '@/core/config/constants'
import {DebugItemList} from '@/core/main/Interface'
import {Attachable} from '@/core/items/base/Attachable'
import {Guide} from '@/core/util/Guide'

import * as svgjs from '@svgdotjs/svg.js'

class DesignCodes {

    private meta: any;

    constructor() {

        if (Init.app_location == APP_LOCATION.OFFICE) {
            this.retrieveItemMetadata();
        }

        Init.emitter.on(APP_EVT.TOGGLE_CODES, this.toggleShowCodes);
        Init.emitter.on(APP_EVT.RETRIEVE_SUCCESS, this.clearCodes);
        Init.emitter.on(APP_EVT.UPDATE_PACKLIST, this.showItemCodes);

        $('#panel-item-codes .handle .btn-close').on('click', function (this) {

            Init.emitter.emit([APP_EVT.TOGGLE_CODES]);

        });

    }


    /**
     * itemlist is all the items in the design that Phoenix needs.
     *
     * packlist is the codes needed for Phoenix import, grouped
     * for display in the app with the quantity number
     */
    getItemDebugCodes = (): any[] => {

        let item_array: any[] = []
        let result: DebugItemList

        //console.log( Init.set_design.items);
        //console.log(item_list.values());
        for (let [svgid, item] of Init.set_design.items) {

            result = item.getDebugPacklist()

            for (let i in result.codes) {

                if (!item_array[result.codes[i]]) {

                    item_array[result.codes[i]] = 1

                } else {

                    item_array[result.codes[i]] += 1
                }
            }

            if (item.roof != undefined) {

                result = item.roof.getDebugPacklist()
                //console.log(result)
                if (result.codes.length > 0 && result.codes[0] != null) {

                    for (let i in result.codes) {

                        if (!item_array[result.codes[i]]) {

                            item_array[result.codes[i]] = 1

                        } else {

                            item_array[result.codes[i]] += 1
                        }
                    }
                }
            }
        }

        if (result) {

            switch (Init.series_id) {
                // the following lines need plaques sent with the playset
                case SERIES_ID.COMMERCIAL_OUTDOOR:
                case SERIES_ID.COMMERCIAL_OUTDOOR_UNDER2:
                case SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
                case SERIES_ID.COMMERCIAL_2ANDOVER:
                case SERIES_ID.FROLIC:

                    result.codes = Init.line.getPacklistCodes()

                    if (result.codes && result.codes.length > 0 && result.codes[0] != null) {

                        for (let i in result.codes) {

                            if (!item_array[result.codes[i]]) {

                                item_array[result.codes[i]] = 1

                            } else {

                                item_array[result.codes[i]] += 1
                            }
                        }
                    }
                    break
            }
        }

        return item_array

    }


    /**
     *
     */
    showItemData = (): void => {

        if (Init.app_location == APP_LOCATION.WWW) {

            let itemlist: any = this.getItemCodes().itemlist;

            let str: string = '<div class="item-codes">';

            for (let item in itemlist) {
                //console.log(item, itemlist[item]);
                if (item != 'undefined')
                    str += item + ' &nbsp; ' + itemlist[item] + '<br>';
            }

            str += '</div>';

            //$('.debug #msg-codes').html(str);
            $('#panel-item-codes #items').html(str);
        }
    };


    /**
     * itemlist is all the items in the design that Phoenix needs.
     *
     * packlist is the codes needed for Phoenix import, grouped
     * for display in the app with the quantity number
     */
    getItemCodes = (): { itemlist: string[], packlist: string[] } => {

        //console.trace();

        let item_list: Map<string, Attachable> = Init.set_design.items;
        let packlist: string[] = [];
        let itemlist: any = {};

        //console.log('list', item_list.values());

        for (let item of item_list.values()) {
            //console.log('list', item);
            if (item.roof != undefined) {

                let code: string[] = item.roof.getPacklistRoofCode();

                //console.log(item.itemName, code);

                if (code.length > 0 && code[0] != null) {

                    packlist = packlist.concat(code);

                }
            }

            let code: string[] = item.getPacklistCodes();

            //console.log(code);
            if (code && code.length > 0) {

                packlist = packlist.concat(code);

            }
        }

        switch (Init.series_id) {

            case SERIES_ID.COMMERCIAL_OUTDOOR:
            case SERIES_ID.COMMERCIAL_OUTDOOR_UNDER2:
            case SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
            case SERIES_ID.COMMERCIAL_2ANDOVER:
            case SERIES_ID.FROLIC:

                packlist = packlist.concat(Init.line.getPacklistCodes())
                break


        }

        //console.log(itemlist, packlist);
        packlist.sort();

        for (let code of packlist) {

            if (itemlist[code] != undefined) {
                itemlist[code] += 1;
            } else {
                itemlist[code] = 1;
            }
        }

        //console.log(itemlist, packlist);
        return {'itemlist': itemlist, 'packlist': packlist};
    };


    /**
     * takes our array of itemcodes and quantities and adds cat_id and descriptions
     *
     */
    showItemCodes = (): void => {

        Guide.displayPersistentNote('hide', '');

        if (Init.app_location == APP_LOCATION.OFFICE) {

            let itemlist: any[] = this.getItemDebugCodes();
            let tmp: string = '';
            let tmp_items: any[] = [];
            let tmp_undefined: any[] = [];

            //console.log('x', itemlist);
            for (let code in itemlist) {

                if (code != 'undefined' && code != '') {

                    if (!this.meta || !this.meta[code] || this.meta[code] == undefined) {

                        //console.log('undefined', code);

                        tmp_undefined.push({
                            code: code,
                            qty: itemlist[code]
                        });

                    } else {

                        tmp_items.push({
                            cat_id: this.meta[code][3],
                            code: code,
                            qty: itemlist[code],
                            type: this.meta[code][0],
                            id: this.meta[code][1],
                            price: this.meta[code][2],
                            desc: this.meta[code][4],
                            oos: this.meta[code][5]
                        });
                    }
                }
            }

            tmp_items.sort(this.objSort);

            let str: string = '<table class="item-list"><tr><th>&nbsp;</th><th>code</th><th>description</th><th>subtotal</th></tr>';
            let total_price: number = 0;
            let css_muted: string = '';
            let price: number = 0;
            let oos_css: string = '';
            let oos_msg: string = '';

            for (let row of tmp_undefined) {

                if (row.code != 'undefined') {

                    str += '<tr>'
                        + '<td>' + row.qty + '</td>'
                        + '<td class="text-danger font-weight-bold">' + row.code + '</td>'
                        + '<td colspan="2">unknown</td>'
                        + '</tr>';

                }
            }

            if (tmp_undefined.length > 0) {
                str += '<tr><td colspan="4" class="divider"><hr></td></tr>';
            }

            for (let row of tmp_items) {

                if (row.code != 'undefined') {

                    oos_css = (row.oos == 1) ? 'text-danger font-weight-bold' : '';

                    if (row.oos == 1) {
                        oos_msg += row.code + ': ' + row.desc + '<br>';
                    }

                    if (tmp != row.cat_id && tmp != '') {
                        str += '<tr><td colspan="4" class="divider"><hr></td></tr>';
                    }

                    css_muted = (row.price == 0) ? 'text-black-20' : '';
                    price = (row.price * 100) * row.qty;

                    str += '<tr>'
                        + '<td>' + row.qty + '</td>'
                        + '<td><a href="http://phoenix.cedarnet.local/' + row.type + '/edit/#' + row.id + '" target="_blank" class="' + oos_css + '">' + row.code + '</a></td>'

                        + '<td>' + row.desc + '</td>'
                        + '<td class="text-end ' + css_muted + '">$' + price / 100 + '</td>'
                        + '</tr>';

                    tmp = row.cat_id;

                    total_price += Number(price);

                }
            }

            str += '<tr><td colspan="4" class="divider"><hr></td></tr>';
            str += '<tr>'
                + '<td colspan="4" class="text-end"><b>$' + (total_price / 100).toFixed(2) + '</b></td>'
                + '</tr>';

            str += '</table>';

            //$('.debug #msg-codes').html(str);
            $('#panel-item-codes #item-codes').html(str);

            if (oos_msg != '') {

                Guide.displayPersistentNote('show', oos_msg);
                //console.log(row.code);
            }
        }
    };


    /**
     * specifically for sorting the item codes for staff into cat_id DESC and item code ASC
     * @param a
     * @param b
     */
    objSort = (a, b): number => {

        let sort: number[] = [1, 8, 9, 7, 2, 3, 4, 5, 6, 0];

        if (sort.indexOf(a.cat_id) < sort.indexOf(b.cat_id)) return -1;
        if (sort.indexOf(a.cat_id) > sort.indexOf(b.cat_id)) return 1;
        if (a.code < b.code) return -1;
        if (a.code > b.code) return 1;
        return 0;
    };


    /**
     *
     */
    retrieveItemMetadata = (): void => {

        //let ItemDesc: any;
        let _that = this;

        $.ajax({
            type: 'GET',
            url: '/appConfig/getItemMetadata',
            //url: '/js/app/ItemMetadata.json?' + new Date().getDate(),
            dataType: 'json',
        })
            .done(function (data) {

                _that.meta = data;

            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log('error', jqXHR, textStatus, errorThrown)
            });

    };

    /** ***************************************************************************
     * ACTIVATE NOTE OPTIONS
     */
    toggleShowCodes = (): void => {

        let state: boolean = Init.codes_active;

        //console.log(state);

        if (state === false) {

            this.showCodes();

        } else {

            this.hideCodes();

        }
    };


    showCodes = (): void => {

        //document.removeEventListener('wheel', Setup.onWheel);

        this.showItemCodes();

        $('#panel-item-codes').fadeIn();

        Init.codes_active = true;

        $('#tool-btns #btn-codes-toggle').addClass('active');

    };

    hideCodes = (): void => {

        //document.addEventListener('wheel', Setup.onWheel);

        //console.log('hideCodes');

        $('#tool-btns .btn-codes-toggle').removeClass('btn-active');

        Init.codes_active = false;

        $('#panel-item-codes').fadeOut();
    };

    clearCodes = (): void => {

        $('#panel-item-codes #item-codes').val('');

    };

    loadCodes = (note: string): void => {

        $('#panel-item-codes #item-codes').val(note);

    };

    getCodes = (): string => {

        return String($('#panel-item-codes #item-codes').val());

    };
}

export {
    DesignCodes
};
